import { IHttpService, IOnChangesObject, IPromise } from 'angular';
import { IPostTrial, ITrial, TrialService, TrialType } from '../../providers';
import template from './desktop-trial-popover-success.html';
import { UserService } from '../../../tn.user/service.tn.user';

export class DesktopTrialPopoverSuccessController {
    static $inject = ['$http', 'tn.user.service', 'trialService'];
    constructor(
        protected $http: IHttpService,
        protected userService: UserService,
        protected trialService: TrialService
    ) {}
    trial?: ITrial;
    tries: number[] = [];
    max_tries = 67; // should be about 15 minutes

    $onChanges(changes: IOnChangesObject): void {
        const trial = changes.trial;
        // console.log('DesktopTrialPopoverSuccessController.$onChanges', {...changes}, this.tries.length);
        if (trial?.currentValue) {
            if (trial.currentValue.file_storage_url) {
                // We have a download url, all done!
                return;
            }

            //give up if we've tried too many ties
            if (this.tries.length >= this.max_tries) {
                return;
            }

            // backoff increases, but caps out at 15 seconds
            let backoff = 1.5 ** this.tries.length + 1 * 1000;
            if (backoff >= 15000) {
                backoff = 15000;
            }

            // if the file generation hasn't completed 
            // then poll for it with expentional backoff.
            setTimeout(() => {
                // console.log('DesktopTrialPopoverSuccessController calling trial service list', performance.now());
                this.trialService.list().then(() => this.tries.push(backoff));
            }, backoff);
        }
    }


    submit(trial: ITrial): IPromise<ITrial> {
        const data: IPostTrial = {
            family_id: trial.family_id,
            trial_type: TrialType.DESKTOP,
        };
        // do the thing.
        return this.trialService.post(data);
    }

    download($event: Event): void {
        console.log('DesktopTrialPopoverSuccessController.download', {
            trial: this.trial,
        });
        $event.preventDefault();
        const trial = this.trial;
        if (!trial) {
            console.error(
                'DesktopTrialPopoverSuccessController.download: no trial'
            );
            return;
        }

        if (!trial.file_storage_url) {
            console.error(
                'DesktopTrialPopoverSuccessController.download: no trial.file_storage_url'
            );
            return;
        }
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = trial.file_storage_url;
        a.target = '_blank';
        a.download = `TN_Trial_${this.trial?.family_name}.zip`;
        document.body.appendChild(a);
        a.click();
        // cleanup
        a.remove();
    }
}

export const DesktopTrialPopoverSuccessComponent = {
    controller: DesktopTrialPopoverSuccessController,
    template,
    bindings: {
        trial: '<',
    },
};
